/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import SetupGuide, { STEPS } from 'cio/models/setup-guide';
import EnvironmentModel from 'cio/models/environment';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import AuthService from 'cio/services/auth';

interface SetupGuideNavArgs {
  setupGuide: SetupGuide;
  environment: EnvironmentModel;
}

export default class SetupGuideNav extends Component<SetupGuideNavArgs> {
  @service auth!: AuthService;

  readonly channelLabels = {
    [MessagingChannelType.Push]: 'Push',
    [MessagingChannelType.Email]: 'Email',
    [MessagingChannelType.Twilio]: 'Twilio',
    [MessagingChannelType.Webhook]: 'Webhooks',
    [MessagingChannelType.Slack]: 'Slack',
    [MessagingChannelType.InApp]: 'In-App',
  };

  get channels() {
    return this.args.setupGuide.messagingChannels.map((channel) => ({
      channel,
      isSetupComplete: this.args.setupGuide.isChannelDoneWithSetup(channel),
    }));
  }

  @computed('args.setupGuide.completedSteps.{source,channels,createCampaign,sendCampaign}')
  get completionBars() {
    return [true, ...STEPS.map((step) => this.args.setupGuide.completedSteps[step])];
  }

  get hasCreateChannelsPermissions() {
    return (
      !this.auth.hasPermission('journeys/campaigns/create') &&
      !this.auth.hasPermission('journeys/broadcasts/create') &&
      !this.auth.hasPermission('journeys/newsletters/create') &&
      !this.auth.hasPermission('journeys/transactional_messages/create')
    );
  }
}
